var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgLiveBadge = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 12,
  fill: "none",
  viewBox: "0 0 30 12",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 12,
  fill: "url(#svg-2423093067__a)",
  rx: 6
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.26 8.957H9.64V7.766H6.6V3h-1.34zM10.71 8.957h1.341V3h-1.34zM15.515 9h1.184l2.463-6h-1.445l-1.593 4.196L14.531 3h-1.48zM20.102 8.957h4.64V7.791h-3.308v-1.25h2.872V5.373h-2.872V4.166h3.264V3h-4.596z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-2423093067__a",
  x1: 0,
  x2: 6.206,
  y1: 0,
  y2: 19.553,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF465D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F711BA"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLiveBadge);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };